import type { ProductCardData } from '@chewy/chat-library-common';
import { SelectableWidgetsContainer } from '@chewy/chat-library-components';
import ProductCard from './ProductCard';

interface ProductCardSelectorProps {
    /**
     * Array of products to display
     */
    data: Array<Partial<ProductCardData>>;
    /**
     * Additional CSS class name
     */
    className?: string;
}

/**
 * Displays a horizontal list of selectable ProductCards
 * Uses SelectableWidgetsContainer to automatically make all cards selectable
 */
export default function ProductCardSelector({
    data,
    className
}: ProductCardSelectorProps) {
    return (
        <SelectableWidgetsContainer direction="horizontal" className={className}>
            {data.map((product, index) => (
                <ProductCard key={index} data={product} />
            ))}
        </SelectableWidgetsContainer>
    );
}
